import { SitePro, SiteTiny } from '../entities';
import { Address } from '../entities/shared/address';
import { JobUtility } from './job.utility';

export class AddressUtility {

    public static isEqual(address1: Address, address2: Address): boolean {

        if (!address1 || !address2) return false;

        if (address1?.street1?.toLowerCase() !== address2?.street1?.toLowerCase())
            return false;

        if (address1?.suburb?.toLowerCase() !== address2?.suburb?.toLowerCase())
            return false;

        if (address1?.state?.toLowerCase() !== address2?.state?.toLowerCase())
            return false;

        if (address1?.postcode !== address2?.postcode)
            return false;

        if (address1.lat !== address2.lat)
            return false;

        if (address1.lgn !== address2.lgn)
            return false;

        if (!address1.lat || !address2.lat)
            return false;

        if (!address1.lgn || !address2.lgn)
            return false;

        return true;
    }

    public static getAddressName(address: Address) {
        //Similar to the above method, but we do not want to show both the site name and address name
        const addressName = address?.name ?? JobUtility.address(address);

        return addressName;
    }

    public static getSiteName(site: SitePro | SiteTiny, notSetText: string = ''): string {

        if (!site) {
            return notSetText;
        }

        let addressName = this.getAddressName(site.address);

        if (site?.name?.length && site.name !== addressName) {
            addressName = `${addressName} (${site.name})`;
        }

        return addressName;
    }
}
